import { CommonService } from './../services/common.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  infoUser: any = {};
  constructor(private common: CommonService, private _router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.common.local.getObject('clientLogin')) {
      return true;
    }

    // navigate to login page
    this._router.navigate(['/ecoportail/login']);
    // you can save redirect url so after authing we can move them back to the page they requested
    return false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuthGuardEcorec  {
  infoUser: any = {};
  constructor(private common: CommonService, private _router: Router) { }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log(next, state)
    const navigatedInternally = this.common.navigatedInternally;
    
    if (!navigatedInternally) {
      this._router.navigateByUrl('/');
      return false;
    } else {
      const callfct = await this.testAccesURLModule(state.url);
      if (state.url === '/' || callfct) {
        return true;
      } else {
        return false;
      }
    }


    // you can save redirect url so after authing we can move them back to the page they requested

  }

  async testAccesURLModule(hash) {
    if (this.common.getID(hash)) {
      return await this.getFctParam(this.common.getID(hash)).then(dt => {
        return true;
      }).catch(err => {
        this._router.navigateByUrl('/');
        return false
      });
    } else {
      return Promise.resolve(true)
    }

  }

  getFctParam(CLEF_MODULE) {
    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 32
        },
        'CLEF_MODULE': {
          'typeParam': 'int',
          'valeur': CLEF_MODULE
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2] || 0
        },
      }
    };

    return this.common.post('', { param: param });
  }
}